//import LoadingSpinner from "components/LoadingSpinner";
import React from 'react';

const DefaultRouteComponent: React.FC = () => {
  return <></>;
};

export default DefaultRouteComponent;
